import React, { useEffect, useRef, useState } from "react"
import { useLocation, Link } from "react-router-dom"
import PropTypes from "prop-types"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import {
  adminMenus,
  investorsMenus,
  wealthPartnerMenus,
} from "routes/sideBarTabs"
import { useDispatch, useSelector } from "react-redux"
import HelpModel from "modals/helpModel"
import { setSidebar } from "store/slices/userSlice"

const SidebarContent = (props) => {
  const scrollRef = useRef()
  const sidebarRef = useRef(null)
  const dispatch = useDispatch()
  const path = useLocation()
  const { permissions, userType, user } = useSelector((state) => state.user)
  const { currentUserMenuType } = useSelector((state) => state.common)
  const [menus, setMenus] = useState([])
  const kycStatus = user.status
  const isMobile = window.innerWidth <= 998

  useEffect(() => {
    if (menus.length > 0) {
      new MetisMenu("#side-menu")
    }
  }, [menus, currentUserMenuType])

  useEffect(() => {
    if (userType) {
      switch (userType) {
        case "ADMIN":
          setMenus(adminMenus)
          break
        case "WEALTH_PARTNER":
          setMenus(wealthPartnerMenus)
          break
        default:
          setMenus(investorsMenus)
          break
      }
    }
  }, [userType])

  const closeSidebar = () => {
    dispatch(setSidebar({ sidebar: false }))
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMobile = window.innerWidth <= 998
      const sidebarIsOpen = document.body.classList.contains("sidebar-enable")

      if (
        sidebarIsOpen &&
        isMobile &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !document.getElementById("vertical-menu-btn")?.contains(event.target)
      ) {
        document.body.classList.remove("sidebar-enable")
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const checkPermissionForAdmin = (keys = [], kycCheck, item = null) => {
    if (item && !item?.menuType.includes(currentUserMenuType)) {
      return false
    }
    const transformedPermission = [...permissions, "DASHBOARD"]
    return transformedPermission.some((t) => keys.includes(t))
  }
  const checkPermissionForInvestor = (keys = [], kycCheck) => {
    const transformedPermission = [...permissions, "DASHBOARD"]

    if (keys.length <= 0) return true

    let isApproved = true
    if (kycCheck && kycStatus !== "APPROVED") isApproved = false

    if (userType === "INVESTOR" && user.user_type !== "SUB_INVESTOR") {
      return isApproved
    }

    return transformedPermission.some((t) => keys.includes(t)) && isApproved
  }
  const checkPermissionForWealth = (keys = [], kycCheck) => {
    if (kycCheck && kycStatus !== "APPROVED") return false
    return true
  }

  const checkPermissionsAccordingtoUserType = (
    keys = [],
    kycCheck,
    item = null
  ) => {
    switch (userType) {
      case "ADMIN":
        return checkPermissionForAdmin(keys, kycCheck, item)
      case "WEALTH_PARTNER":
        return checkPermissionForWealth(keys, kycCheck)

      case "INVESTOR":
        return checkPermissionForInvestor(keys, kycCheck)
    }
  }

  const checkUserType = (entity) => {
    if (!entity) return true
    if (entity && Array.isArray(entity)) {
      return entity.includes(user?.entity_type)
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu" ref={sidebarRef}>
        <SimpleBar className="h-100" ref={scrollRef}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              {menus.map((item, index) => {
                const isActive = path.pathname.includes(item.tab)
                return (
                  <React.Fragment key={`tab_${index}`}>
                    {item?.isSectionHeading === "title"
                      ? checkPermissionsAccordingtoUserType(
                          item.permission
                        ) && <li className={item.className}>{item.name}</li>
                      : checkPermissionsAccordingtoUserType(
                          item.permission,
                          item?.kycCheck,
                          item
                        ) && (
                          <>
                            {((item.isMobile === true && isMobile) ||
                              (item.isMobile === false && !isMobile) ||
                              item.isMobile === undefined) && (
                              <li className={isActive ? "mm-active" : ""}>
                                <Link
                                  to={item.path}
                                  onClick={() => {
                                    if (
                                      item.subTabs.length <= 0 &&
                                      window.innerWidth <= 998
                                    ) {
                                      document.body.classList.remove(
                                        "sidebar-enable"
                                      )
                                      closeSidebar()
                                    }
                                  }}
                                  className={`${
                                    item.subTabs.length > 0 ? "has-arrow" : ""
                                  } ${!isActive ? "mm-collapsed" : ""}`}
                                  aria-expanded={isActive}
                                >
                                  {item.icon && <i className={item.icon}></i>}
                                  <span>{props.t(item.name)}</span>
                                </Link>
                                {item.subTabs.length > 0 && (
                                  <ul
                                    className={`${item.className} mm-collapse ${
                                      isActive ? "mm-show" : ""
                                    }`}
                                  >
                                    {item.subTabs.map((sub, i) => {
                                      if (!sub?.subTabs) {
                                        const isActiveSub =
                                          isActive && sub.path === path.pathname
                                        return (
                                          checkPermissionsAccordingtoUserType(
                                            sub.permission,
                                            sub.kycCheck,
                                            sub
                                          ) &&
                                          checkUserType(sub?.entity) && (
                                            <li
                                              key={`tab_${index}_${i}`}
                                              className={
                                                isActiveSub ? "mm-active" : ""
                                              }
                                              onClick={() => {
                                                if (window.innerWidth <= 998) {
                                                  document.body.classList.remove(
                                                    "sidebar-enable"
                                                  )
                                                  closeSidebar()
                                                }
                                              }}
                                            >
                                              <Link
                                                className={
                                                  isActiveSub ? "active" : ""
                                                }
                                                to={sub.path}
                                              >
                                                {sub.icon && (
                                                  <i className={sub.icon}></i>
                                                )}
                                                <span>
                                                  {" "}
                                                  {props.t(sub.name)}
                                                </span>
                                              </Link>
                                            </li>
                                          )
                                        )
                                      } else if (sub?.subTabs?.length > 0) {
                                        const isActiveSub =
                                          isActive &&
                                          path.pathname.includes(sub.tab)

                                        return (
                                          checkPermissionsAccordingtoUserType(
                                            sub.permission,
                                            sub.kycCheck,
                                            sub
                                          ) && (
                                            <li
                                              key={`tab_${index}_${i}`}
                                              className={
                                                isActiveSub ? "mm-active" : ""
                                              }
                                            >
                                              <Link
                                                className={
                                                  isActiveSub
                                                    ? "active second-level"
                                                    : "second-level"
                                                }
                                                to={sub.path}
                                              >
                                                {sub.icon && (
                                                  <i className={sub.icon}></i>
                                                )}
                                                <span>
                                                  {" "}
                                                  {props.t(sub.name)}
                                                </span>
                                              </Link>

                                              <ul
                                                className={` ${
                                                  sub.className
                                                } mm-collapse ${
                                                  isActiveSub ? "mm-show" : ""
                                                }`}
                                              >
                                                {sub.subTabs.map(
                                                  (element, idx) => {
                                                    const isTabActive =
                                                      isActive &&
                                                      isActiveSub &&
                                                      element.path ===
                                                        path.pathname
                                                    if (
                                                      !checkUserType(
                                                        element?.entity
                                                      )
                                                    )
                                                      return null
                                                    return (
                                                      <li
                                                        key={`third_tab_${index}_${i}_${idx}`}
                                                        className={
                                                          isTabActive
                                                            ? "mm-active"
                                                            : ""
                                                        }
                                                        onClick={() => {
                                                          if (
                                                            window.innerWidth <=
                                                            998
                                                          ) {
                                                            document.body.classList.remove(
                                                              "sidebar-enable"
                                                            )
                                                            closeSidebar()
                                                          }
                                                        }}
                                                      >
                                                        <Link
                                                          className={
                                                            isTabActive
                                                              ? "active"
                                                              : ""
                                                          }
                                                          to={element.path}
                                                        >
                                                          {element.icon && (
                                                            <i
                                                              className={
                                                                element.icon
                                                              }
                                                            ></i>
                                                          )}
                                                          <span>
                                                            {props.t(
                                                              element.name
                                                            )}
                                                          </span>
                                                        </Link>
                                                      </li>
                                                    )
                                                  }
                                                )}
                                              </ul>
                                            </li>
                                          )
                                        )
                                      }
                                    })}
                                  </ul>
                                )}
                              </li>
                            )}
                          </>
                        )}
                  </React.Fragment>
                )
              })}
            </ul>
            {/* <div className="side-bar-profile-menu-section">
              <ProfileMenu />
            </div> */}
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
